// import React from "react";
import { Link } from "react-router-dom";
// import footerTopData from "./FooterTopData.json";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import { cleanUrl } from "../../../Utils/utils";

const FooterTopMenus = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: footerTopMenus = {}, isLoading: footerTopMenusLoading } =
    useGetProtectedApiDataQuery({
      url: "mastermenu-footer",
      lang: languageType,
    });

  const confirmProtectedRoute = (e, path) => {
    if (path === "/reservoir-status") {
      const proceed = window.confirm(
        "This page is protected. Do you want to proceed to check authentication?",
      );
      if (!proceed) {
        e.preventDefault(); // stop navigation
        return;
      }
    }
  };

  const menuItems = footerTopMenus?.menu_items || [];

  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-9 print-social1">
      <div className="foot-nav wow fadeInLeft">
        <ul>
          {footerTopMenusLoading ? (
            <li>Loading menus...</li>
          ) : menuItems.length > 0 ? (
            menuItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={cleanUrl(item?.url)}
                  title={item.title}
                  onClick={(e) => confirmProtectedRoute(e, cleanUrl(item?.url))}
                >
                  {item.title}
                </Link>
              </li>
            ))
          ) : (
            <li>No menu found</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default FooterTopMenus;
